module.exports = __webpack_public_path__ + "img/student_34.f98c8442.png";